var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-button",class:{ full: _vm.full },style:({ width: _vm.width })},[_c('div',{staticClass:"ui-button-container",class:[_vm.color, { disabled: _vm.disabled }]},[_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }